/* eslint-disable jira/filename-case */
import { getWindow } from '@jira/ssr__browser-globals/src/getWindow.tsx';

export const transformStargateUrl = (url: string): string => {
	try {
		if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
			const urlObject = new URL(url);
			let urlPathArray = urlObject.pathname.split('/');
			urlPathArray = ['gateway', 'api', ...urlPathArray.slice(1)];
			return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
		}
	} catch (e) {
		return url;
	}
	return url;
};

export const transformCreateIssueUrl = ({
	issueUrl,
	selectedCloudId,
}: {
	issueUrl: string;
	selectedCloudId: string;
}): string => {
	if (!selectedCloudId) return issueUrl;
	return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
};

export const transformOriginUrl = (selectedCloudId: string): string | null => {
	if (!selectedCloudId) return null;
	const origin = getWindow()?.origin;
	return origin ? `${origin}/gateway/api/ex/jira/${selectedCloudId}` : null;
};
